export default {
    state: {
        eventsTypes: defaultEventTypes()
    },
    mutations: {
        addEventType(state, eventTypeName) {
            if (!state.eventsTypes.includes(eventTypeName)) {
                state.eventsTypes.unshift(eventTypeName)
            }
        }
    },

    getters: {
        getEventTypes(state) {
            return state.eventsTypes
        },
        getDefaultEventTypes() {
            return defaultEventTypes()
        },
        getReservedEventTypes() {
            return reservedEventTypes()
        },
        getReservedParameterNames() {
            return reservedParameterNames()
        },
        getReservedParameterPrefixes() {
            return reservedParameterPrefixes()
        },
    },
    namespaced: true
}

function defaultEventTypes() {
   return [
       'purchase',
       'generate_lead',
       'sign_up',
       'custom'
   ]
}

function reservedEventTypes() {
    return [
        //Web
        'app_remove',
        'app_store_refund',
        'app_store_subscription_cancel',
        'app_store_subscription_renew',
        'click',
        'error',
        'file_download',
        'first_open',
        'first_visit',
        'form_start',
        'form_submit',
        'in_app_purchase',
        'page_view',
        'scroll',
        'session_start',
        'user_engagement',
        'view_complete',
        'video_progress',
        'video_start',
        'view_search_results',
         //Mobile'
        'ad_activeview',
        'ad_click',
        'ad_exposure',
        'ad_impression',
        'ad_query',
        'ad_reward',
        'adunit_exposure',
        'app_clear_data',
        'app_exception',
        'app_install',
        'app_remove',
        'app_store_refund',
        'app_update',
        'app_upgrade',
        'dynamic_link_app_open',
        'dynamic_link_app_update',
        'dynamic_link_first_open',
        'error',
        'firebase_campaign',
        'firebase_in_app_message_action',
        'firebase_in_app_message_dismiss',
        'firebase_in_app_message_impression',
        'first_open',
        'first_visit',
        'in_app_purchase',
        'notification_dismiss',
        'notification_foreground',
        'notification_open',
        'notification_receive',
        'notification_send',
        'os_update',
        'screen_view',
        'session_start',
        'user_engagement',
    ]
}

function reservedParameterNames() {
    return [
        // Web
        'engagement_time_msec',
        'gclid',
        'session_id',
        'session_number',
        //Mobile
        'firebase_conversion'
    ]
}

function reservedParameterPrefixes() {
    return [
        '_ (underscore)',
        'firebase_',
        'ga_',
        'google_',
        'gtag.'
    ]
}
